import { useContext } from "react"
import _ from "lodash"

//Context
import { AssessmentFormulaBuilderContext } from "../../../../../../context/assessmentFormulaBuilderContext"

//PrimeReact
import { InputText } from "primereact/inputtext"
import { InputNumber } from "primereact/inputnumber"
import { Dropdown } from "primereact/dropdown"

//Styles
import myStyles from "../../../../../../styles/assessments/ManagementFormulaBuilder.module.css"
import assessStyles from "../../../../../../styles/assessments/Assessment.module.css"
import Droppable from "../../Droppable"
import RenderFormula from "./RenderFormula"
import { Panel } from "primereact/panel"
import formulaBuilderTypes from "../formulaBuilderTypes"
import { useState } from "react"
import { Button } from "primereact/button"
import RenderFormulaConnector from "./RenderFormulaConnector"
import RenderFormulaClose from "./RenderFormulaClose"

export default function RenderFormulaGroup({
  formulaOrder,
  dndRef,
  dndStyle,
  dndAttributes,
  dndListeners,
  hideConnector,
  overConnectorId,
}) {
  const { onUpdateFormulaEntry } = useContext(AssessmentFormulaBuilderContext)

  const groupProfile = formulaOrder?.group

  const functionOptions = [
    formulaBuilderTypes.getFunction(formulaBuilderTypes.functionNames.abs),
    formulaBuilderTypes.getFunction(formulaBuilderTypes.functionNames.round),
  ]

  return (
    <>
      {!hideConnector ? (
        <div className={myStyles.formulaRenderLayoutConnector}>
          <RenderFormulaConnector
            connector={groupProfile?.connectingOperator}
            formulaId={formulaOrder?.id}
            overConnectorId={overConnectorId}
          />
        </div>
      ) : null}

      <div className={myStyles.formulaGroupContainer}>
        <Panel
          header={
            <div
              className={myStyles.formulaRenderGroupHeaderLayout}
              {...dndAttributes}
              {...dndListeners}
              style={dndStyle}
              ref={dndRef}
            >
              <div className={`${myStyles.formulaRenderGroupHeaderLayoutName}`}>
                <InputText
                  value={groupProfile?.title}
                  placeholder="Add title"
                  className={myStyles.formulaRenderGroupLayoutTitleInput}
                  onChange={(e) => {
                    let newValue = _.cloneDeep(formulaOrder)
                    newValue.group.title = e.target.value

                    onUpdateFormulaEntry(newValue)

                    e.stopPropagation()
                  }}
                  onKeyDown={(e) => {
                    e.stopPropagation()
                  }}
                  onMouseDown={(e) => {
                    e.stopPropagation()
                  }}
                  onFocus={(e) => {
                    e.stopPropagation()
                  }}
                />
              </div>

              <div className={myStyles.formulaRenderGroupHeaderLayoutControls}>
                <RenderFormulaClose formulaOrderid={formulaOrder.id} />
                <Button
                  className={`${assessStyles.actionButton} ${myStyles.formulaRenderGroupHeaderLayoutControlsButton}`}
                  type="button"
                  tooltip="Drag this element to order it in the list"
                  tooltipOptions={{ position: "bottom" }}
                >
                  <span className={`material-icons`}>{"drag_indicator"}</span>
                </Button>
              </div>
            </div>
          }
          toggleable
          className={`${myStyles.formulaGroupContainer}`}
        >
          <div className={myStyles.formulaRenderGroupLayout}>
            <div className={myStyles.formulaRenderGroupLayoutFormula}>
              <Dropdown
                className={myStyles.formulaRenderGroupLayoutFormulaInput}
                placeholder="No function applied"
                value={groupProfile.groupFunctionType}
                options={functionOptions}
                optionLabel="display"
                optionValue="name"
                onChange={(e) => {
                  let newValue = _.cloneDeep(formulaOrder)
                  newValue.group.groupFunctionType = e.value

                  if (e.value === formulaBuilderTypes.functionNames.round) {
                    newValue.group.groupFunctionAttribute = 0
                  } else {
                    newValue.group.groupFunctionAttribute = undefined
                  }

                  onUpdateFormulaEntry(newValue)
                }}
              />
            </div>
            <div className={myStyles.formulaRenderGroupLayoutAttributeLabel}>
              {groupProfile.groupFunctionType ===
              formulaBuilderTypes.functionNames.round
                ? "Precision"
                : null}
            </div>
            <div className={myStyles.formulaRenderGroupLayoutAttribute}>
              {groupProfile.groupFunctionType ===
              formulaBuilderTypes.functionNames.round ? (
                <InputNumber
                  value={groupProfile.groupFunctionAttribute}
                  onChange={(e) => {
                    let newValue = _.cloneDeep(formulaOrder)
                    newValue.group.groupFunctionAttribute = e.value

                    onUpdateFormulaEntry(newValue)
                  }}
                  className={myStyles.formulaRenderAttributeInput}
                  showButtons
                  buttonLayout="horizontal"
                  min={0}
                />
              ) : null}
            </div>
            <div className={myStyles.formulaRenderGroupLayoutBody}>
              <Droppable
                id={`FormulaGroup_${groupProfile?.id}`}
                className={`${myStyles.formulaRenderGroupLayoutBodyDroppable} ${
                  groupProfile?.formulas?.length === 0
                    ? myStyles.formulaRenderGroupLayoutBodyEmpty
                    : ""
                }`}
              >
                {groupProfile?.formulas?.length === 0 ? (
                  <>{">> Add question, number or function here <<"}</>
                ) : (
                  <>
                    {groupProfile?.formulas.map((formula, index) => {
                      if (!formula?.id) {
                        return <>Unknown formula type</>
                      }

                      return (
                        <RenderFormula
                          formulaOrder={formula}
                          key={formula?.id}
                          hideConnector={index === 0}
                        />
                      )
                    })}
                    <div
                      className={`${myStyles.formulaRenderGroupLayoutBodySpacer}`}
                    >
                      Add new <br />
                      item
                    </div>
                  </>
                )}
              </Droppable>
            </div>
          </div>
        </Panel>
      </div>
    </>
  )
}
